/**
 * P4-12: Credits 对话框。
 *
 * 取代 index.html `#creditsDiv` 的静态致谢文案。
 */
import { useDialog } from "../components/Dialog";

export default function CreditsDialog() {
  const { closeTopDialog } = useDialog();

  return (
    <div className="credits-dialog">
      <p>CSS themes: shrx, Kida, Volkeyrn (see top bar of each theme).</p>
      <p>Code contributions:</p>
      <ul>
        <li><a href="http://www.reddit.com/user/Zusias" target="_blank" rel="noreferrer">Zusias</a></li>
        <li>Duke</li>
        <li title="For years of dedication and support"><a href="http://www.reddit.com/user/xranti" target="_blank" rel="noreferrer">xranti</a></li>
        <li><a href="http://www.reddit.com/user/klusark" target="_blank" rel="noreferrer">klusark</a></li>
        <li title="For save editor, inspiration and years of dedication and support"><a href="https://coderpatsy.bitbucket.io/" target="_blank" rel="noreferrer">coderpatsy</a></li>
        <li>ArcanisCz</li>
        <li>Kida</li>
        <li title="For years of dedication and support">freeroot</li>
        <li title="For years of dedication and support">Ethaniel</li>
        <li title="Alpha branch, challenges, years of contribution">Kyogre</li>
        <li title="For years of managing IRC and the wiki">wikimon</li>
        <li title="Policies design and being a Grand Mufti">Hunter</li>
        <li title="For years of dedication and support">Ziggurat</li>
        <li title="Exploration, general code stuff">plcp_</li>
        <li title="Themes implementation">Volkeyrn</li>
        <li title="help with i18n and localization"><a href="http://www.reddit.com/user/Pellax" target="_blank" rel="noreferrer">PellaAndroid</a></li>
        <li title="Endless help and Buddha-like patience">Brent</li>
      </ul>

      <p>Thanks a lot to 4chan/igg for being such nice guys.</p>
      <p>Thanks a lot to /r/kittensgame community for all the feedback and testing.</p>
      <p>Special thanks to Kittens Game discord mods and members.</p>
      <p>Special thanks for anyone who is not in the list, we still love you &lt;3</p>
      <p>tumblr icon by <a href="https://moonlight-pendent13.deviantart.com" target="_blank" rel="noreferrer">Moonlight-pendent13</a></p>
      <p>Warmest thanks to <a href="http://www.reddit.com/user/ainil" target="_blank" rel="noreferrer">ainil</a> for the long months of support and feedback during the formative days of KG.</p>
      <p>Thanks to mothloveslamp for supporting me and keeping me sane in my darkest hours.</p>
      <p>And finally, my undying gratitude to Waraiko.</p>

      <button type="button" onClick={closeTopDialog}>Close</button>
    </div>
  );
}
